module.exports = __webpack_public_path__ + "static/media/29BDOS16.a07b9500.jpg";